import {SystemNotification} from "../models/system-notifications.model";

export class SendToast {
    static readonly type = '[toast] send toast';
    constructor(public message: SystemNotification) {}
}

export class SendClickableToast {
  static readonly type = '[toast] send clickable toast';
  constructor(public message: SystemNotification) {}
}

// dismiss message
export class DismissToast {
    static readonly type = '[toast] dismiss toast';
    constructor(public index: number) {}
}
